import { Helmet } from 'react-helmet-async'

const HelmetComponent = ({ title, meta, link }) => {
  return (
    <Helmet>
      <title>{title}</title>
      {meta?.map((item, index) => (
        <meta {...item} key={index} />
      ))}
      {link?.map((item, index) => (
        <link {...item} key={index} />
      ))}
    </Helmet>
  )
}
export default HelmetComponent
